<h1>Messaging Colors</h1>

<div class="box box__danger1">
  $danger
</div>
<div class="box box__danger2">
  $danger
</div>
<div class="box box__warn1">
  $warn
</div>
<div class="box box__warn2">
  $warn
</div>
<div class="box box__info1">
  $info
</div>
<div class="box box__info2">
  $info
</div>
<div class="box box__success1">
  $success
</div>
<div class="box box__success2">
  $success
</div>
<div class="clearfix"></div>